import Typography from '../components/Typography';
import Layout from '../components/Layout';
import { useNavigate } from '@reach/router';

const ScanIcon = ({ size = 128, className = '' }) => {
  return (
    <div
      className={`content-stretch flex items-center justify-center relative ${className}`}
      style={{ width: `${size}px`, height: `${size}px` }}
      data-name="Container"
      data-node-id="953:33313"
    >
      <div
        className="bg-[#eff6ff] content-stretch flex items-center justify-center relative rounded-[9999px] shrink-0 size-full"
        data-name="Background"
        data-node-id="953:33314"
      >
        <div
          className="content-stretch flex flex-col items-start relative shrink-0"
          data-name="Container"
          data-node-id="953:33315"
        >
          <div className="flex items-center justify-center relative shrink-0">
            <div className="-scale-y-100 flex-none">
              <div
                className="h-[76px] relative w-[64px]"
                data-name="Icon"
                data-node-id="953:33316"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="64"
                  height="76"
                  viewBox="0 0 64 76"
                  fill="none"
                >
                  <path
                    d="M5.61133 24.8053V11.6109H18.8058V16.8887H10.8891V24.8053H5.61133ZM5.61133 64.3887V51.1942H10.8891V59.1109H18.8058V64.3887H5.61133ZM45.1947 64.3887V59.1109H53.1113V51.1942H58.3891V64.3887H45.1947ZM53.1113 24.8053V16.8887H45.1947V11.6109H58.3891V24.8053H53.1113ZM46.5141 52.5137H50.4724V56.472H46.5141V52.5137ZM46.5141 44.597H50.4724V48.5553H46.5141V44.597ZM42.5558 48.5553H46.5141V52.5137H42.5558V48.5553ZM38.5974 52.5137H42.5558V56.472H38.5974V52.5137ZM34.6391 48.5553H38.5974V52.5137H34.6391V48.5553ZM42.5558 40.6387H46.5141V44.597H42.5558V40.6387ZM38.5974 44.597H42.5558V48.5553H38.5974V44.597ZM34.6391 40.6387H38.5974V44.597H34.6391V40.6387ZM50.4724 19.5276V35.3609H34.6391V19.5276H50.4724ZM29.3613 40.6387V56.472H13.528V40.6387H29.3613ZM29.3613 19.5276V35.3609H13.528V19.5276H29.3613ZM25.403 52.5137V44.597H17.4863V52.5137H25.403ZM25.403 31.4026V23.4859H17.4863V31.4026H25.403ZM46.5141 31.4026V23.4859H38.5974V31.4026H46.5141Z"
                    fill="#1A237E"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const ScanCard = () => {
  const navigate = useNavigate();
  return (
    <Layout className="pt-52 px-8">
      <ScanIcon className="mb-10 mx-auto" />
      <Typography className="mb-4 text-[24px] text-center" weight="bold">
        Scan your card
      </Typography>
      <Typography className="mb-14 text-[14px] text-center">
        Point your camera at the QR code on the card to start loading it.
      </Typography>
      <button
        className="mb-6 cz-btn-brand w-full"
        onClick={() => navigate(`/gift-redeem/load`)}
      >
        Open Camera
      </button>
      <Typography className="mb-4 text-[12px] text-center" color="secondary">
        Don't have the card with you?
      </Typography>
      <Typography
        className="text-[14px] text-center"
        color="orange"
        weight="bold"
      >
        Save this link for later
      </Typography>
    </Layout>
  );
};

export default ScanCard;
